import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmBreadcrumb',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    itemListElement: function itemListElement() {
      var items = this.items.slice();
      items.shift();
      return items.map(function (value, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            name: value.label,
            '@id': value.url
          }
        };
      });
    },
    structuredData: function structuredData() {
      return {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: this.itemListElement
      };
    }
  },
  head: function head() {
    return {
      script: [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify(this.structuredData),
        body: true
      }]
    };
  }
};